module.exports = __webpack_public_path__ + "static/img/p4.88d56119.png";